import BaseView from './_BaseView.js';
import Table from "../components/Table";
import Api from "../Api";
import Confirm from "../components/Confirm";

export default class PathwayView extends BaseView {
    constructor() {
        super();
        this.formSelector = '#pathwayForm';
        this.formUrl = '/api/pathway';
        this.formTpl = 'pathway-form-simple';
        this.formTitle = Lang.pathway;
        this.defaultObject = {
            title: '',
            description: ''
        };
        this.formCallback = function () {
            this.table.reload();
        };
    }

    init() {
        super.init();

        if ($('#pathwayTable').length > 0) {
            this.table = new Table('pathwayTable', '/api/pathway/table', [
                {data: 'order', orderable: true},
                {data: 'title', orderable: true},
                {data: 'description'},
                {data: 'guides', orderable: false},
                {data: 'roles', orderable: false},
                {data: 'tools', orderable: false},
            ]);
        }
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const pathways = $('#pathwayTable');

        pathways.on('click', '.edit', function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/pathway/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });

        // delete
        pathways.on('click.appdel', '.delete', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            Confirm({
                ok: Lang.delete,
                title: name,
                msg: `${Lang.delsure}<br><br><strong class="msg-box danger">${Lang.delundone}</strong>`,
                onConfirm: function () {
                    Api.send(`/api/pathway/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });
        });

        // sort buttons are in GuideView
        $('.reorder-pathways').on('click', function () {
            self.reorderPathways();
            return false;
        });

        $('.add-pathway-form').on('click', function () {
            self.renderForm();
            return false;
        });
    }

    reorderPathways() {
        const self = this;
        Api.send('/api/pathway').done(function (p) {
            Api.getTpl('reorder-form').done(function (r) {
                const tpl = _.template(r);

                Confirm({
                    ok: Lang.save,
                    title: Lang.pathways,
                    msg: tpl({items: p}),
                    classes: 'large-modal',
                    onConfirm: function () {
                        const data = {pathways: []};
                        $('#reorderForm input').each(function () {
                            data.pathways.push($(this).val());
                        });
                        Api.send('/api/pathway/reorder', data, 'post').done(function () {
                            self.table.reload();
                        });

                    }
                });
            });
        });
    }
}
